import React, { useState, useEffect } from "react";
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, Pagination, Typography, CircularProgress
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { db } from '../firebase';
import Swal from "sweetalert2";
import {
    collection,
    getDocs,
    deleteDoc,
    doc,
} from "firebase/firestore";

const Inactivecontacts = () => {
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [loading, setLoading] = useState(false);

    const fetchContacts = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, "contacts"));
            const arr = querySnapshot.docs
                .map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }))
                .filter(item => item.status === "Inactive"); // ✅ Only Inactive Filter

            setList(arr);
        } catch (err) {
            Swal.fire("Error", "Failed to load inactive contacts!", "error");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchContacts();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Delete?",
            text: "This contact will be permanently removed!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Delete"
        }).then(async (res) => {
            if (res.isConfirmed) {
                await deleteDoc(doc(db, "contacts", id));
                Swal.fire("Deleted!", "Contact removed!", "success");
                fetchContacts();
            }
        });
    };

    const total = list.length;
    const paginatedList = list.slice((page - 1) * limit, page * limit);

    return (
        <Box p={3}>
            <Typography variant="h5" fontWeight="900" mb={3}>
                Inactive Contacts
            </Typography>

            <TableContainer component={Paper} sx={{ borderRadius: 2, minHeight: 150 }}>
                <Table>
                    <TableHead sx={{ backgroundColor: "#ffe2e2" }}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Parent Name</TableCell>
                            <TableCell>Mobile</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>WhatsApp</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    <CircularProgress size={26} />
                                </TableCell>
                            </TableRow>
                        ) : paginatedList.length > 0 ? (
                            paginatedList.map((row, index) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                                    <TableCell>{row.parentName}</TableCell>
                                    <TableCell>{row.mobile}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.whatsapp}</TableCell>
                                    <TableCell sx={{ color: "red", fontWeight: "600" }}>
                                        {row.status}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton color="error" onClick={() => handleDelete(row.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center">No Inactive Contacts Found ❌</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {total > limit && (
                <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(e, val) => setPage(val)}
                    sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                    shape="rounded"
                />
            )}
        </Box>
    );
};

export default Inactivecontacts;
